import { GetterTree } from 'vuex';
import { RootState } from '../RootState';
import { CommonState } from './types';

export const getters: GetterTree<CommonState, RootState> = {
  locations: (state: CommonState) => {
    return state.locations;
  },
};
